/** TopDataのAPI */
import * as topData from './repositories/top-data'
/** 学校検索のAPI */
import * as school from './repositories/school'
/** AppliDataのAPI */
import * as appliData from './repositories/appli-data'

/** 外部API */
import * as external from './repositories/external'

export default { topData, school, appliData, external }

export type { Get$Params as TopData$Get$Params, Get$Response as TopData$Get$Response } from './repositories/top-data'

export type {
  Search$Params as School$Search$Params,
  Search$Response as School$Search$Response,
} from './repositories/school'

export type {
  Get$Params as AppliData$Get$Params,
  Get$Response as AppliData$Get$Response,
  Set$Data as AppliData$Set$Data,
  Set$Params as AppliData$Set$Params,
  Set$Response as AppliData$Set$Response,
  Validate$Data as AppliData$Validate$Data,
  Validate$Params as AppliData$Validate$Params,
  Validate$Response as AppliData$Validate$Response,
  Confirm$Data as AppliData$Confirm$Data,
  Confirm$Params as AppliData$Confirm$Params,
  Confirm$Response as AppliData$Confirm$Response,
} from './repositories/appli-data'
